<script>
import { mapActions } from 'vuex';
import { useAlert } from 'dashboard/composables';

export default{
  name: "EditAllowedValuesModal",
  props: {
    editKey: {
      type: String,
      required: true,
    },
    editObj: {
      type: Object,
      required: true,
    }
  },
  data(){
    return{
      allowedValues: [],
      isLoading: false,
      newValue: "",
    }
  },
  methods: {
    ...mapActions('gsheet', ['editColumnAllowedValues']),
    addValue() {
      if (this.newValue && !this.allowedValues.includes(this.newValue)) {
      this.allowedValues.push(this.newValue);
      }
      this.newValue = "";
    },
    removeValue(index) {
      this.allowedValues.splice(index, 1);
    },
    async handleConfirm(){
      const payload =  {
        knowledgeId: this.$route.params.GSheetKBId,
        columnName: this.editKey, 
        allowed_values: [...this.allowedValues]
      }
      try{  
        this.isLoading = true;
        await this.editColumnAllowedValues(payload);
        this.$emit('refresh')
        this.$emit('close')
      }catch(err){
        console.error(err);
        useAlert('Error edit allowed values columns')
      }finally{
        this.isLoading = false;
      }
    }
  },
  mounted(){
    if(this.editObj.allowed_values){
      this.allowedValues = this.editObj.allowed_values;
    }
  }
}
</script>

<template>
  <div class="fixed inset-0 flex items-center justify-center bg-slate-800/80 dark:bg-slate-800/80 z-50">
    <div class="bg-white dark:bg-slate-900 rounded-lg p-6 shadow-lg w-96 max-h-[80vh] overflow-y-auto border border-slate-200 dark:border-slate-700">
      <!-- header -->
      <div class="flex items-center mb-4 justify-between">
        <h1 class="text-xl font-bold text-slate-900 dark:text-slate-100">
          Edit Column Allowed Values
        </h1>
        <woot-button
          variant="clear"
          color-scheme="alert"
          icon="dismiss"
          @click="$emit('close')"
        />
      </div>

      <form class="space-y-4" @submit.prevent>
        <!-- Allowed Values -->
        <div>
          <label class="block mb-1 text-slate-700 dark:text-slate-300">
            Allowed Values:
          </label>
          <!-- Input for new value -->
          <div class="flex gap-2">
            <input
              v-model="newValue"
              @keyup.enter.prevent="addValue"
              type="text"
              placeholder="Type and press Enter..."
              class="reset-base p-2 rounded w-full border bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-100 placeholder-slate-400 dark:placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-woot-500 dark:focus:ring-woot-400 border-slate-200 dark:border-slate-700"
            />
            <woot-button
              type="button"
              icon="add"
              @click="addValue"
            />
          </div>

          <!-- Pills for existing values -->
          <div class="flex flex-wrap gap-2 mt-2">
            <span
              v-for="(val, idx) in allowedValues"
              :key="idx"
              class="flex items-center gap-1 px-2 py-1 rounded-full bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm"
            >
              {{ val }}
              <button
                type="button"
                @click="removeValue(idx)"
                class="text-slate-500 hover:text-red-500"
              >
                ✕
              </button>
            </span>
          </div>
        </div>
      </form>

      <!-- Action buttons -->
      <div class="flex justify-end gap-4 mt-6">
        <woot-button color-scheme="secondary" @click="$emit('close')">
          Cancel
        </woot-button>
        <woot-button @click="handleConfirm" :is-loading="isLoading">
          Update
        </woot-button>
      </div>
    </div>
  </div>
</template>